import apiAxios from 'helpers/apiAxios';
import { downloadBlob } from 'helpers/exportCsv';

// Filters kept in the URL → query params the API understands. Empty values are
// dropped so the URL and the request stay short.
export const FILTER_KEYS = ['category', 'outcome', 'action_name', 'user_id', 'project_id', 'q', 'ip', 'from', 'to', 'include_system'];

export const toApiParams = (filters = {}) => FILTER_KEYS.reduce((acc, key) => {
  const value = filters[key];
  return value === undefined || value === null || value === '' ? acc : { ...acc, [key]: value };
}, {});

export const fetchAuditLogs = async ({ filters, page, perPage }) => {
  const { data } = await apiAxios.get('/audits', { params: { ...toApiParams(filters), page, per_page: perPage } });
  return { rows: data?.data || [], total: data?.total_rows || 0, capped: !!data?.total_capped };
};

export const fetchAuditLog = async (id) => {
  const { data } = await apiAxios.get(`/audits/${id}`);
  return data?.data;
};

export const fetchAuditFacets = async () => {
  const { data } = await apiAxios.get('/audits/facets');
  return data?.data || { categories: [], outcomes: [], actions: [] };
};

export const exportAuditLogs = async (filters) => {
  const response = await apiAxios.get('/audits/export', { params: toApiParams(filters), responseType: 'blob' });
  const stamp = new Date().toISOString().slice(0, 10);
  downloadBlob(response.data, `audit-logs-${stamp}.csv`);
};

export const fetchMyAuditLogs = async ({ page = 1, perPage = 20 } = {}) => {
  const { data } = await apiAxios.get('/audits/mine', { params: { page, per_page: perPage } });
  return { rows: data?.data || [], total: data?.meta?.total_rows || 0 };
};
